// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"918f972c","732":"ef1b4231","977":"4c8ab578"}[chunkId] + ".chunk.js";
};